export const UNCLAIMED_ICON_SIZE = [ 26, 27 ]
export const CLAIMED_ICON_SIZE = [ 42, 44 ]
export const VERIFIED_ICON_SIZE = [ 48, 51 ]
export const FEATURED_ICON_SIZE = [ 54, 57 ]
export const PREMIUM_ICON_SIZE = [ 66, 80 ]
